module.exports = __webpack_public_path__ + "img/about.83ba1833.png";